export function mergeRecordById(record, idHash, idKey = "id") {
  const id = record[idKey];
  const merged = {
    ...idHash[id],
    ...record,
  };
  return {
    ...idHash,
    [id]: merged,
  };
}
